import { EntityTypes } from '../../../utilities/Constants';
import { INoteModel } from '../../../interfaces/INote';
import { IUserModel } from '../../../interfaces/IUser';
import { NoteList } from '../../notes/NoteList';
import { useNoteCategoryTypes } from '../../../shared/react-query-hooks/useNoteCategoryTypes';
import { useZoneContext } from '../../../contexts/useZoneContext';

export interface INoteListWrapperProps {
    entityType: EntityTypes;
    notes: INoteModel[];
    title?: string;
    titleClassName?: string;
    user: IUserModel;
    onAddNote: () => void;
    onViewEditNote: (noteGuid: string, readOnly?: boolean) => void;
    onRefreshParent?: (notes: INoteModel[]) => void;
    readonly?: boolean;
    noteType: number;
    strategyType?: number;
}

export function NoteListWrapper(props: INoteListWrapperProps) {
    const zoneContext = useZoneContext();
    const caseNoteCategoriesApi = useNoteCategoryTypes(props.entityType);

    if (caseNoteCategoriesApi.isLoading) {
        return <div>Loading...</div>;
    }

    return (
        <NoteList
            title={props.title}
            titleClassName={props.titleClassName}
            user={props.user}
            notes={props.notes}
            noteCategoryTypes={caseNoteCategoriesApi.data ?? []}
            handleViewEditNote={props.onViewEditNote}
            handleAddNote={props.onAddNote}
            showExpertsColumn={true}
            refreshParent={(notes) => {
                if (props.onRefreshParent) {
                    props.onRefreshParent(notes);
                }
            }}
            readonly={props.readonly}
            zoneContext={zoneContext}
            noteType={props.noteType}
            strategyType={props.strategyType}
        />
    );
}
